import styled from 'styled-components'

const ProductStyle = styled.div`
display:flex;
padding: .5rem 0;
img {
    width: 58px;
    height: 58px;
    border: 1px solid #DCDCDC;
    border-radius: 6px;
    margin: 0 10px 0 0;
}
h5 {
    font-size: 14px;
    margin: 0px;
    font-weight: 400;
}
p{
    font-size: 12px !important;
    font-weight: 200;

}

`;

const ImgDefault = styled.div`
background-image: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 1000 1000' fill='%23eaeaea' enable-background='new 0 0 1000 1000' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M908.4,908.4H91.7c-45.2,0-81.7-36.5-81.7-81.7V336.6c0-45,36.5-81.6,81.7-81.6H255v-81.7c0-45.2,36.5-81.7,81.6-81.7h326.7c45.2,0,81.8,36.5,81.8,81.7V255h163.3c45.1,0,81.6,36.5,81.6,81.6v490.1C990,871.9,953.5,908.4,908.4,908.4L908.4,908.4L908.4,908.4z M132.4,336.6c-22.5,0-40.8,18.4-40.8,40.9c0,22.5,18.4,40.8,40.8,40.8c22.5,0,40.8-18.3,40.8-40.8C173.3,354.9,155,336.6,132.4,336.6L132.4,336.6L132.4,336.6z M549.9,336.6h-92c-114.4,21.6-201,121.8-201,242.6c0,136.4,110.6,247.1,247,247.1c136.4,0,247.1-110.7,247.1-247.1C751.1,458.4,664.6,358.3,549.9,336.6L549.9,336.6L549.9,336.6z M494.1,706.1c-68.2,0-123.7-55.5-123.7-123.7c0-68.3,55.4-123.5,123.7-123.5c68.2,0,123.6,55.2,123.6,123.5C617.4,650.8,562.2,706.1,494.1,706.1L494.1,706.1L494.1,706.1z'/%3E%3C/g%3E%3C/svg%3E");
background-size: 45px;
width: 58px;
height: 58px;
padding: 0px;
background-position: center;
background-repeat: no-repeat;
border: 1px solid #DCDCDC;
border-radius: 6px;
margin-right: 10px;
`;

export const SimpleProduct = ({ sku, name, quantity, imageUrl }) => {

    return (
        <ProductStyle>
            {imageUrl ? <img src={imageUrl} alt={name} /> : <ImgDefault></ImgDefault> }

            <span className='description'>
            <h5>{name}</h5>
            <p>Cantidad: {quantity}</p>
            </span>
        </ProductStyle>
    )
}